import React from "react";
import {
  HiChevronDoubleDown,
  HiChevronDoubleUp,
  HiChevronUp,
} from "react-icons/hi";
import { TfiLineDouble } from "react-icons/tfi";

export enum ENMPriority {
  "LOW" = "Low",
  "MEDIUM" = "Medium",
  "HIGH" = "High",
  "URGENT" = "URGENT",
}

export type TYPPriority = keyof typeof ENMPriority;

type Props = {
  priority: TYPPriority;
};

const getClassNameByPriroty = (priority: TYPPriority) => {
  switch (priority) {
    case "LOW":
      return "text-[#008000]"; // Green for low priority

    case "MEDIUM":
      return "text-[#FFC700]"; // Blue for medium priority

    case "HIGH":
      return "text-[#FF7A00]"; // Red for high priority

    case "URGENT":
      return "text-[#FF0000]"; // A slightly darker red for urgent priority
  }
};

const getIconsByPriroty = (priority: TYPPriority) => {
  switch (priority) {
    case "LOW":
      return <HiChevronDoubleDown color="#008000" size={22} />;

    case "MEDIUM":
      return <TfiLineDouble color="#FFC700" size={22} />;

    case "HIGH":
      return <HiChevronUp color="#FF7A00" size={22} />;

    case "URGENT":
      return <HiChevronDoubleUp color="#FF0000" size={22} />;
  }
};

const MOLPriorityChip = ({ priority }: Props) => {
  const className = ` 
  font-medium
  rounded-full
  py-[2px]
  text-[14px]
  flex gap-x-2
    ${getClassNameByPriroty(priority)}`;

  return (
    <div className={className}>
      {getIconsByPriroty(priority)} {ENMPriority[priority]}{" "}
    </div>
  );
};

export default MOLPriorityChip;
